<div class="padding-bottom-15">
  <mat-label>{{dropdownData.title}}</mat-label>
  <ng-select appendTo="body" [compareWith]="compareFn" [multiple]="true" [virtualScroll]="true" placeholder="Select {{dropdownData.title}}" (change)="chosenOptions()" [(ngModel)]="selectedValues">
    <ng-option *ngFor="let item of dropdownData.values" [value]="item">{{item}}</ng-option>
  </ng-select>
</div>

